<template>
  <div class="signed-out flex justify-content-center">
    <div class="card">
      <img class="block logo" :src="whqLogoColorBlack" alt="WarehouseQuote Logo" />
      <Message :closable="false" v-if="route.path === '/session-expired'">Session expired. Please sign in&nbsp;again.</Message>
      <Message severity="success" :closable="false" v-if="$route.path === '/signed-out'">You have been successfully signed&nbsp;out.</Message>
      <p class="my-4"><a href="mailto:itsupport@warehousequote.com?subject=WarehouseQuote.com%20Web%20Application">Contact us</a> if you have any questions or&nbsp;inquiries.</p>
      <Button class="block sign-in p-button-rounded" label="Return to Sign In" @click="restartApplication()" />
    </div>
  </div>
</template>

<script setup>
  import whqLogoColorBlack from "@/images/whq-logo-color-black-horizontal.png";
  import { useRoute, useRouter } from "vue-router";
  import AuthenticationService from "@/services/AuthenticationService.js";
  const route = useRoute(), router = useRouter();

  // remove layout-mode-dark from the html class list, and remove tokens from localstorage
  document.documentElement.classList.remove("layout-mode-dark");
  AuthenticationService.removeTokensFromLocalStorage();

  function restartApplication() {
    if (route.path === "/session-expired" && router.referrer) {
      window.location = router.referrer;
    } else {
      window.location = "/";
    }
  }
</script>

<style lang="scss" scoped>
  .signed-out {
    height: 100vh;
    background-color: #909090;
  }
  .card {
    align-self: start;
    border-radius: 0;
    margin: 10px 25px;
    box-shadow: 0 3px 9px rgba(#000, 0.5);
    max-width: 375px;
    font-family: Arial,Helvetica,sans-serif;
    @media(min-width: $breakpoint-md) {
      margin: 30px 25px;
      box-shadow: 0 5px 15px rgba(#000, 0.5);
    }
  }
  .logo {
    max-width: 240px;
    margin: 26px auto 33px auto;
  }
  .sign-in {
    width: 200px;
    height: 48px;
    font-family: Arial,Helvetica,sans-serif;
    font-size: 16px;
    font-weight: normal;
    margin: 0 auto 14px auto;
    color: #fff;
    background-color: #1da3d9;
    border-radius: 99px;
    border: none;
    display: block;
  }
</style>